export const config = {
  documentsBffBaseUrl: process.env.REACT_APP_DOCUMENTS_BFF_BASEURL || "https://documents-bff-dev.agyo.io",
  documentExperimentalFeature: process.env.REACT_APP_EXPERIMENTAL_FEATURES,
  digitalBoxBaseUrl: process.env.REACT_APP_DBOX_BASEURL || "https://appdev.teamsystemdigital.com/digitalbox/#/",
  gainsightEnvKey: process.env.GAINSIGHT_ENV_KEY || "AP-45IEUH6FL6DY-2-4" 
};
